<template>
  <div class="container">
    <div class="login_body">
      <h1>用户登录</h1>
      <el-form>
        <el-form-item>
          <el-input placeholder="用户名" v-model="loginParam.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="密码" :key="passwordType" ref="password" type="password" v-model="loginParam.password"  @focus="focus('psw')" @blur="blur('psw')"></el-input>
          <!-- <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span> -->
        </el-form-item>
        <el-form-item class="captcha">
          <el-input v-model="loginParam.verifyInput" type="text" placeholder="请输入验证码"></el-input>
          <img :src="captcha" alt="" @click="getVerify" class="verify_img">
        </el-form-item>
        <el-form-item>
          <button class="login_button" @click.prevent="login">登&nbsp;&nbsp;录</button>
          <!-- <button class="regis-btn" @click="register">立即注册</button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as loginApi from '@/api/login';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
import { localStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      userName: '',
      captcha: '',
      password: '',
      passwordType: '',
      dataRule: {
        userName: [
          { required: true, message: '帐号不能为空', trigger: 'blur' }
        ],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      loginParam: {}
    };
  },
  created() {
    this.getVerify();
  },
  methods: {
    getVerify() {
      this.captcha = '/log/getVerify?d=' + Math.random();
    },
    submitForm() {},
    login() {
      loginApi.login(this.loginParam).then(res => {
        this.setToken(res.data.token);
        localStorage.set('token', res.data.token);
        this.$router.push({
          path: '/admin'
        });
      });
    },
    ...mapMutations({
      setToken: mutationsType.SET_TOKEN
    }),
    register() {
      this.$router.push({ name: 'register' });
    },
    focus(m) {
      if (m === 'user') {
        this.userIcon = '#006980';
        this.userBottom = '1px solid #006980';
      } else {
        this.pswIcon = '#006980';
        this.pswBottom = '1px solid #006980';
      }
    },
    blur(m) {
      if (m === 'user') {
        this.userIcon = '#bbbbbb';
        this.userBottom = '1px solid #e8e8e8';
      } else {
        this.capsTooltip = false;
        this.pswIcon = '#bbbbbb';
        this.pswBottom = '1px solid #e8e8e8';
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.container {
  height: 100%;
  width: 100%;
  background-image: linear-gradient(30deg, #50aba4 20%, #92deaf 80%);
  box-sizing: border-box;
  padding-top: 170px;

  .login_button {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
    font-size: 16px;
    font-weight: 100;
    border-radius: 5px;
    background-color: #f66f26;
    color: #fff;
    border: 1px solid rgba(238, 238, 238, 0.41);
    border-width: thin;
  }

  .login_body {
    position: relative;
    width: 20%;
    margin: 0 auto;
    padding: 40px;
    background-color: rgba(42, 42, 42, 0.2);
    border-radius: 5px;
    border-bottom: 0;
    border-bottom-left-radius: initial;
    border-bottom-right-radius: initial;
    height: 275px;

    h1 {
      color: #ffffff;
      text-align: center;
      font-size: 22px;
      font-weight: 300;
    }
  }
}

.captcha {
  overflow: hidden;
}

.captcha img {
  float: right;
  width: 35%;
  vertical-align: middle;
  height: 40px;
}

.captcha .el-input {
  width: 50%;
  float: left;
}

.bean_pwd {
  height: 36px;
  border: 1px solid #c0c4cc;
  width: 258px;
  border-radius: 4px;
  text-indent: 1em;
  /* letter-spacing:10px; */
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/login.vue